import { RichContentType } from '../../../../generated/graphql'
import { productListMock1, sharedFacets } from './ProductListMocks'

export const MOCK_PRODUCT_LIST_DATA = {
  path: '/health-beauty/face/view-all-skincare',
  title: 'View All Skincare Products - LOOKFANTASTIC UK',
  concession: {
    concessionCode: null,
    header: null,
    footer: null,
    __typename: 'Concession',
  },
  metaDescription:
    'Find a wide range of moisturisers, cleansers and special treatments from Skincare from luxury brands on LOOKFANTASTIC. Available with free UK delivery available now.',
  breadcrumbs: [
    {
      __typename: 'Breadcrumb',
      displayName: 'Home',
      pagePath: '/',
    },
    {
      __typename: 'Breadcrumb',
      displayName: 'Skin Care',
      pagePath: '/health-beauty/face',
    },
    {
      __typename: 'Breadcrumb',
      displayName: 'View all Skincare',
      pagePath: '/health-beauty/face/view-all-skincare',
    },
  ],
  alternateLinks: [
    {
      locale: 'en_MY',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'de_AT',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'ru_RU',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'el_GR',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'it_IT',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'pl_PL',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'ro_RO',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'en_AU',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'th_TH',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'ja_JP',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'fr_FR',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'cs_CZ',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'de_DE',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'nb_NO',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'ar_SA',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'zh_TW',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'en_HK',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'es_ES',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'nl_NL',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'sv_SE',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'da_DK',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'en_SG',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'en_IE',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'fi_FI',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'en_GB',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'ko_KR',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'en_CA',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'en_US',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'en_AE',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'en_IN',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'zh_CN',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'ar_AE',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
    {
      locale: 'pt_PT',
      pagePath: '/health-beauty/face/view-all-skincare',
      __typename: 'PageAlternateLink',
    },
  ],
  widgets: [
    {
      __typename: 'TopProductCategorySet',
      id: 'responsiveSlot14',
      showDiscoverTag: '',
      showMore: 'true',
      DiscoverTitle: '',
      banners: [
        {
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Complexion',
          topProductCategoryUrl: '/health-beauty/make-up/complexion.list',
        },
        {
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Eyes and Brows',
          topProductCategoryUrl: '/health-beauty/make-up/eyes.list',
        },
        {
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Lips',
          topProductCategoryUrl: '/health-beauty/make-up/lips.list',
        },
        {
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Make up Brushes & Accessories',
          topProductCategoryUrl:
            '/health-beauty/make-up/makeup-accessories.list',
        },
      ],
    },
    {
      __typename: 'ProductListWidget',
      id: 'responsiveSlot15',
      title: 'View all Skincare',
      descriptionHtml: {
        content: [
          {
            content:
              "Keep your skin looking radiant and flawless with the complete Skincare range from Lookfantastic. Featuring a luxury range of skincare designed for your daily routine or to give your skin that once a week nourishment it needs to keep clear and fresh. \n<p><br></p>\n<p>Featuring moisturisers, cleaners and toners that take part of your daily routine. Removing dirt and grime from your skin as well as hydrating and nourishing to leave you with a complexion that's taken care of before you leave the house or go to bed. <br></p>\n<p>Give your skin a more precise treatment with the peels, serums and concentrates developed to condition your skin and provide you with complexion changing results that you'll love. <br><br></p>",
            __typename: 'RichContentItem',
            type: RichContentType.Html,
          },
        ],
        __typename: 'RichContent',
      },
    },
  ],
  __typename: 'Page',
}

export const MOCK_PRODUCT_LIST_PRODUCTS = {
  widgets: [
    {
      __typename: 'TopProductCategorySet',
      id: 'responsiveSlot14',
      showDiscoverTag: '',
      showMore: 'true',
      DiscoverTitle: '',
      banners: [
        {
          id: 'responsiveSlot14-banners-1',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Complexion',
          topProductCategoryUrl: '/health-beauty/make-up/complexion.list',
        },
        {
          id: 'responsiveSlot14-banners-2',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Eyes and Brows',
          topProductCategoryUrl: '/health-beauty/make-up/eyes.list',
        },
        {
          id: 'responsiveSlot14-banners-3',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Lips',
          topProductCategoryUrl: '/health-beauty/make-up/lips.list',
        },
        {
          id: 'responsiveSlot14-banners-4',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Make up Brushes & Accessories',
          topProductCategoryUrl:
            '/health-beauty/make-up/makeup-accessories.list',
        },
      ],
    },
    {
      id: 'productList',
      __typename: 'ProductListWidget',
      products: {
        __typename: 'ProductList',
        total: 7421,
        facets: sharedFacets,
        products: productListMock1,
      },
    },
  ],
  __typename: 'Page',
}

export const MOCK_WIDGET_DATA = {
  path: '/homeware',
  title: 'Homeware | The Hut',
  concession: {
    concessionCode: null,
    header: null,
    footer: null,
    __typename: 'Concession',
  },
  metaDescription:
    'Shop the designer homeware range at The Hut. Choose from a variety of brands and items & enjoy free UK delivery on orders over £50.',
  breadcrumbs: [
    {
      __typename: 'Breadcrumb',
      displayName: 'Home',
      pagePath: '/',
    },
    {
      __typename: 'Breadcrumb',
      displayName: 'Homeware',
      pagePath: '/homeware',
    },
  ],
  alternateLinks: [
    {
      locale: 'en_GB',
      pagePath: '/test/gravity-widgets',
      __typename: 'PageAlternateLink',
    },
  ],
  widgets: [
    {
      __typename: 'ResponsiveSliderSet',
      id: 'responsiveSlot1',
      banners: [
        {
          __typename: 'GlobalPrimaryBanner',
          ctaTwoURL: '',
          imageMedium:
            'https://s1.thcdn.com/widgets/79-en/36/Page-002-091036.jpg',
          ctaTwo: '',
          contentTheme: 'light',
          contentAlign: 'left',
          bannerURL: '/homeware/bedding.list',
          altLogoPng: '',
          ctaTwoAriaLabel: '',
          ctaOne: '',
          logopngWhiteBG: null,
          imageLarge:
            'https://s1.thcdn.com/widgets/79-en/40/original-The_Hut_Main_Banner_Update_-_Untitled_Page-091640.jpg',
          ctaOneAriaLabel: '',
          logopngImageBG: null,
          useH1: '',
          subtitle: 'New in bedding',
          imageSmall:
            'https://s1.thcdn.com/widgets/79-en/19/original-Page-003-091119.jpg',
          contentBoxPosition: 'left',
          headline: 'In focus',
          ctaOneURL: '/homeware/bedding.list',
          altImageLarge: 'New Bedding',
        },
        {
          __typename: 'GlobalPrimaryBanner',
          ctaTwoURL: '',
          imageMedium:
            'https://static.thcdn.com/images/large/webp/widgets/79-en/15/Page-002-030915.jpg',
          ctaTwo: '',
          contentTheme: 'light',
          contentAlign: 'left',
          bannerURL: '/homeware/bedding.list',
          altLogoPng: '',
          ctaTwoAriaLabel: '',
          ctaOne: '',
          logopngWhiteBG: null,
          imageLarge:
            'https://static.thcdn.com/images/xlarge/webp/widgets/79-en/39/original-Page-001-031039.jpg',
          ctaOneAriaLabel: '',
          logopngImageBG: null,
          useH1: '',
          subtitle:
            'Prepare and organise you space for the autumn with handy essentials from brands OXO, Attirecare, Brabantia and more!',
          imageSmall:
            'https://static.thcdn.com/images/medium/webp/widgets/79-en/24/original-Page-003-030924.jpg',
          contentBoxPosition: 'left',
          headline: 'In focus: Autumnal tidying',
          ctaOneURL: '/homeware/bedding.list',
          altImageLarge: 'New Bedding',
        },
      ],
      isHeightVariable: '',
      slideDuration: null,
      isBulletNavigationHidden: '',
      isAutoSlideOn: 'true',
    },
    {
      __typename: 'GlobalImageCardSet',
      id: 'responsiveSlot2',
      noBorder: false,
      title: 'Image Card Set as overlay',
      banners: [
        {
          __typename: 'GlobalImageCard',
          image:
            'https://s1.thcdn.com/widgets/79-en/12/original-13204851-6244900806841518-112512.jpg',
          buttonText: '',
          colorOfText: 'dark',
          altText: 'Yvonne Ellen',
          verticalPositionOfText: 'bottom',
          subtitle: '',
          noBorder: false,
          title: 'Yvonne Ellen',
          url: '/brands/yvonne-ellen.list',
        },
        {
          __typename: 'GlobalImageCard',
          image:
            'https://s1.thcdn.com/widgets/79-en/37/original-12659927-1294802892220566-114137.jpg',
          buttonText: '',
          colorOfText: 'light',
          altText: 'Christmas Decorations',
          verticalPositionOfText: 'bottom',
          subtitle: '',
          noBorder: false,
          title: 'Christmas Decorations',
          url: '/offers/christmas/decorations.list',
        },
        {
          __typename: 'GlobalImageCard',
          image:
            'https://s1.thcdn.com/widgets/79-en/16/original-0915-QVN054-AP-TH-AW20-HOMESHOOT-BATCH-4-368x368_Blog_Card_Set-114916.jpg',
          buttonText: '',
          colorOfText: 'light',
          altText: 'Guest Room Decorations',
          verticalPositionOfText: 'bottom',
          subtitle: '',
          noBorder: false,
          title: 'Guest Room Decorations',
          url:
            '/catalogue/home-garden/shop-by-room/bedroom/prepare-for-guests.list',
        },
        {
          __typename: 'GlobalImageCard',
          image:
            'https://s1.thcdn.com/widgets/79-en/07/original-IMG_2375-112307.jpg',
          buttonText: '',
          colorOfText: 'dark',
          altText: 'Coffee Table Books',
          verticalPositionOfText: 'bottom',
          subtitle: '',
          noBorder: false,
          title: 'Coffee Table Books',
          url: '/homeware/stationery/books.list',
        },
        {
          __typename: 'GlobalImageCard',
          image:
            'https://s1.thcdn.com/widgets/79-en/12/original-Image_%282%29-115912.jpg',
          buttonText: '',
          colorOfText: 'light',
          altText: 'Autumnal Cooking',
          verticalPositionOfText: 'bottom',
          subtitle: '',
          noBorder: false,
          title: 'Autumnal Cooking',
          url: '/homeware/cooking-dining/pots-pans.list',
        },
        {
          __typename: 'GlobalImageCard',
          image:
            'https://s1.thcdn.com/widgets/79-en/35/original-PLASTIC_13189677-112735.jpg',
          buttonText: '',
          colorOfText: 'dark',
          altText: 'In focus: Zwilling',
          verticalPositionOfText: 'bottom',
          subtitle: '',
          noBorder: false,
          title: 'In focus: Zwilling',
          url: '/brands/zwilling.list',
        },
      ],
      cardStyle: 'image-text-overlay',
    },
    {
      __typename: 'ResponsiveProductTabs',
      id: 'responsiveSlot3',
      tabTitle_1: 'New arrivals',
      responsiveProductTabsTitle: 'Trending right now',
      tabTitle_2: 'Best sellers',
      tabTitle_3: '',
    },
    {
      __typename: 'GlobalPrimaryBanner',
      id: 'responsiveSlot4',
      ctaTwoURL: '',
      imageMedium: 'https://s1.thcdn.com/widgets/79-en/36/Page-002-091036.jpg',
      ctaTwo: '',
      contentTheme: 'light',
      contentAlign: 'left',
      bannerURL: '/homeware/bedding.list',
      altLogoPng: '',
      ctaTwoAriaLabel: '',
      ctaOne: '',
      logopngWhiteBG: null,
      imageLarge:
        'https://s1.thcdn.com/widgets/79-en/40/original-The_Hut_Main_Banner_Update_-_Untitled_Page-091640.jpg',
      ctaOneAriaLabel: '',
      logopngImageBG: null,
      useH1: '',
      subtitle: 'New in bedding',
      imageSmall:
        'https://s1.thcdn.com/widgets/79-en/19/original-Page-003-091119.jpg',
      contentBoxPosition: 'left',
      headline: 'In Focus',
      ctaOneURL: '/homeware/bedding.list',
      altImageLarge: 'New Bedding',
    },
    {
      __typename: 'GlobalBrandLogos',
      id: 'responsiveSlot5',
      itemTwoURL: '/brands/le-creuset.list',
      itemSixURL: '/brands/joseph-joseph.list',
      itemThreeImageAlt: 'Denby',
      itemTwoImage:
        'https://s1.thcdn.com/widgets/79-en/57/LOGO-LECREUSET-014657.png',
      itemFiveImage:
        'https://s1.thcdn.com/widgets/79-en/23/LOGO-TOM-DIXON-014723.png',
      itemThreeURL: '/brands/denby.list',
      itemFourImageAlt: 'HAY',
      itemFiveURL: '/brands/tom-dixon.list',
      itemSixImage:
        'https://s1.thcdn.com/widgets/79-en/30/LOGO-JOSEPH-JOSEPH-014730.png',
      itemFourImage:
        'https://s1.thcdn.com/widgets/79-en/14/LOGO-HAY-014714.png',
      title: '',
      itemTwoImageAlt: 'Le Creuset',
      itemFourURL: '/brands/hay.list',
      itemThreeImage:
        'https://s1.thcdn.com/widgets/79-en/09/LOGO-DENBY-014709.png',
      brandLogosItemOneVariantURL: '',
      titleAlign: '',
      itemOneImageAlt: 'Bloomingville',
      itemFiveImageAlt: 'Tom Dixon',
      itemSixImageAlt: 'Joseph Joseph',
      isScrollable: '',
      itemOneURL: '/brands/bloomingville.list',
      brandLogosItemOneImageVariantAlt: '',
      itemOneImage:
        'https://s1.thcdn.com/widgets/79-en/30/LOGO-BLOOMINGVILLE-031430.png',
      brandLogosItemOneImageVariant: null,
    },
    {
      __typename: 'GlobalBrandLogos',
      id: 'responsiveSlot6',
      itemTwoURL: '/brands/le-creuset.list',
      itemSixURL: '/brands/joseph-joseph.list',
      itemThreeImageAlt: 'Denby',
      itemTwoImage:
        'https://s1.thcdn.com/widgets/79-en/57/LOGO-LECREUSET-014657.png',
      itemFiveImage:
        'https://s1.thcdn.com/widgets/79-en/23/LOGO-TOM-DIXON-014723.png',
      itemThreeURL: '/brands/denby.list',
      itemFourImageAlt: 'HAY',
      itemFiveURL: '/brands/tom-dixon.list',
      itemSixImage:
        'https://s1.thcdn.com/widgets/79-en/30/LOGO-JOSEPH-JOSEPH-014730.png',
      itemFourImage:
        'https://s1.thcdn.com/widgets/79-en/14/LOGO-HAY-014714.png',
      title: '',
      itemTwoImageAlt: 'Le Creuset',
      itemFourURL: '/brands/hay.list',
      itemThreeImage:
        'https://s1.thcdn.com/widgets/79-en/09/LOGO-DENBY-014709.png',
      brandLogosItemOneVariantURL: '',
      titleAlign: true,
      itemOneImageAlt: 'Bloomingville',
      itemFiveImageAlt: 'Tom Dixon',
      itemSixImageAlt: 'Joseph Joseph',
      isScrollable: 'true',
      itemOneURL: '/brands/bloomingville.list',
      brandLogosItemOneImageVariantAlt: '',
      itemOneImage:
        'https://s1.thcdn.com/widgets/79-en/30/LOGO-BLOOMINGVILLE-031430.png',
      brandLogosItemOneImageVariant: null,
    },
    {
      __typename: 'GlobalMultiButton',
      id: 'responsiveSlot7',
      multiButtonWidget_itemOneCTAText: 'SPF & Tan',
      multiButtonWidget_itemOneURL: '/health-beauty/body/spf-tan.list',
      multiButtonWidget_itemTwoCTAText: 'Travel Size',
      multiButtonWidget_itemTwoURL:
        '/offers/summer-shop/travel-essentials.list',
      multiButtonWidget_itemThreeCTAText: 'Summer Fragrance',
      multiButtonWidget_itemThreeURL:
        '/health-beauty/fragrance/summer-fragrance.list',
      multiButtonWidget_itemFourCTAText: 'Summer Body',
      multiButtonWidget_itemFourURL: '/health-beauty/body/spf-tan.list',
      multiButtonWidget_buttonStyle: '',
    },
    {
      __typename: 'GlobalFourButtonLink',
      id: 'responsiveSlot8',
      buttonUrlOne: '/health-beauty/body/spf-tan.list',
      buttonTextOne: 'SPF & Tan',
      buttonUrlTwo: '/offers/summer-shop/travel-essentials.list',
      buttonTextTwo: 'Travel Size',
      buttonUrlThree: '/health-beauty/fragrance/summer-fragrance.list',
      buttonTextThree: 'Summer Fragrance',
      buttonUrlFour: '/health-beauty/body/spf-tan.list',
      buttonTextFour: 'Summer Body',
    },
    {
      __typename: 'GlobalTwoItemEditorial',
      id: 'responsiveSlot9',
      itemTwoTitle: 'Top 10 Best Products from The Ordinary',
      itemTwoURL: '/blog/discover/best-the-ordinary-skincare-products/',
      itemOneCTAText: 'READ MORE',
      itemTwoImage:
        'https://s1.thcdn.com/widgets/95-en/21/TO_Blog_4-051421.jpg?width=660&height=440',
      altItemTwo: '',
      itemTwoCTAText: 'READ MORE',
      itemOneTitle: 'Which Skincare from The Ordinary is Right for Me?',
      widgetTitle: '',
      itemOneDescription:
        'Not sure where to start? Our useful guide helps you to choose the skincare products best suited to your needs.',
      itemOneURL:
        '/blog/advice/which-skincare-from-the-ordinary-is-right-for-me/',
      widgetSubtitle: '',
      itemTwoDescription:
        'Discover the bestselling products from the skincare brand you need on your radar.',
      altItemOne: '',
      itemOneImage:
        'https://s1.thcdn.com/widgets/95-en/30/TO_Blog_2-050730.jpg?width=660&height=440',
    },
    {
      __typename: 'GlobalThreeItemEditorial',
      altItemOne: '',
      altItemThree: '',
      altItemTwo: '',
      id: 'responsiveSlot10',
      itemOneCTAText: 'SHOP NOW',
      itemOneDescription:
        'Target signs of ageing with the skincare designed to reduce fine lines and wrinkles to reveal a youthful-looking complexion.',
      itemOneImage:
        'https://s1.thcdn.com/widgets/95-en/13/original-0913-STDCRE-21708-LF-EJ-Deciem_Brand-Batching-Shot_01507_x_417-050113.jpg?width=660&height=440',
      itemOneSubtitle: '',
      itemOneTitle: 'Anti Ageing',
      itemOneUrl:
        'https://www.lookfantastic.com/brands/the-ordinary/educating-with-the-ordinary/antiageing.list',
      itemOne_secondaryCTAText: '',
      itemOne_secondaryCTAUrl: '',
      itemThreeCTAText: 'SHOP NOW',
      itemThreeDescription:
        "Kick blemish or acne-prone skin to the kerb with the need-to-know products that'll keep pesky pimples at bay.",
      itemThreeImage:
        'https://s1.thcdn.com/widgets/95-en/13/original-0913-STDCRE-21708-LF-EJ-Deciem_Brand-Batching-Shot_01507_x_417-050113.jpg?width=660&height=440',
      itemThreeSubtitle: '',
      itemThreeTitle: 'Blemish',
      itemThreeUrl:
        'https://www.lookfantastic.com/brands/the-ordinary/educating-with-the-ordinary/blemish.list',
      itemThree_secondaryCTAText: '',
      itemThree_secondaryCTAUrl: '',
      itemTwoCTAText: 'SHOP NOW',
      itemTwoDescription:
        'Uneven skin tone? Meet the chemical exfoliants, including topical acids and Vitamin C, that work to target melanin production and promote a brighter, more even complexion.',
      itemTwoImage:
        'https://s1.thcdn.com/widgets/95-en/42/original-0913-STDCRE-21708-LF-EJ-Deciem_Brand-Batching-Shot_02507_x_417-050142.jpg?width=660&height=440',
      itemTwoSubtitle: '',
      itemTwoTitle: 'Pigmentation',
      itemTwoUrl:
        'https://www.lookfantastic.com/brands/the-ordinary/educating-with-the-ordinary/pigmentation.list',
      itemTwo_secondaryCTAText: '',
      itemTwo_secondaryCTAUrl: '',
      pagePath: '/brands/the-ordinary/educating-with-the-ordinary',
      threeItemItemOneAltTextVariant: '',
      threeItemItemOneCTATextVariant: '',
      threeItemItemOneDescriptionVariant: '',
      threeItemItemOneImageVariant: null,
      threeItemItemOneSubtitleVariant: '',
      threeItemItemOneTitleVariant: '',
      threeItemItemOneVariantUrl: '',
      useCircularImages: '',
      widgetHeadingSize: '',
      widgetSubtitle: '',
      widgetTitle: "WHAT'S YOUR SKINCARE CONCERN?",
      widgetType: 'GlobalThreeItemEditorial',
    },
    {
      __typename: 'GlobalThreeItemEditorialSubtitleBG',
      id: 'responsiveSlot11',
      description: '',
      itemTwoTitle: 'Top 10 Best Products from The Ordinary',
      itemTwoSubtitle: '',
      itemTwoUrl: '/blog/discover/best-the-ordinary-skincare-products/',
      itemOneCTAText: 'READ MORE',
      itemTwoImage:
        'https://s1.thcdn.com/widgets/95-en/21/TO_Blog_4-051421.jpg?width=660&height=440',
      itemTwoSubtitleBGColour: '',
      itemTwoAltText: '',
      itemTwoCTAText: 'READ MORE',
      itemOneTitle: 'Which Skincare from The Ordinary is Right for Me?',
      title: '',
      itemOneDescription:
        'Not sure where to start? Our useful guide helps you to choose the skincare products best suited to your needs.',
      itemOneUrl:
        '/blog/advice/which-skincare-from-the-ordinary-is-right-for-me/',
      itemOneSubtitle: '',
      itemTwoDescription:
        'Discover the bestselling products from the skincare brand you need on your radar.',
      itemOneAltText: '',
      itemOneImage:
        'https://s1.thcdn.com/widgets/95-en/30/TO_Blog_2-050730.jpg?width=660&height=440',
      itemOneSubtitleBGColour: '',
      itemThreeTitle: 'Blemish',
      itemThreeUrl:
        'https://www.lookfantastic.com/brands/the-ordinary/educating-with-the-ordinary/blemish.list',
      itemThreeCTAText: 'SHOP NOW',
      itemThreeImage:
        'https://s1.thcdn.com/widgets/95-en/21/TO_Blog_4-051421.jpg?width=660&height=440',
      itemThreeDescription:
        "Kick blemish or acne-prone skin to the kerb with the need-to-know products that'll keep pesky pimples at bay.",
      itemThreeSubtitle: '',
      itemThreeSubtitleBGColour: '',
      itemThreeAltText: '',
    },
    {
      __typename: 'GlobalFourItemEditorial',
      id: 'responsiveSlot12',
      itemTwoTitle: 'Top 10 Best Products from The Ordinary',
      itemTwoSubtitle: '',
      itemTwoUrl: '/blog/discover/best-the-ordinary-skincare-products/',
      itemOneCTA: 'READ MORE',
      itemTwoImage:
        'https://s1.thcdn.com/widgets/95-en/21/TO_Blog_4-051421.jpg?width=660&height=440',
      altItemTwo: '',
      itemTwoCTA: 'READ MORE',
      itemOneTitle: 'Which Skincare from The Ordinary is Right for Me?',
      itemOneSubtitle: '',
      widgetTitle: '',
      itemOneDescription:
        'Not sure where to start? Our useful guide helps you to choose the skincare products best suited to your needs.',
      itemOneUrl:
        '/blog/advice/which-skincare-from-the-ordinary-is-right-for-me/',
      widgetSubtitle: '',
      widgetLinkText: '',
      itemTwoDescription:
        'Discover the bestselling products from the skincare brand you need on your radar.',
      altItemOne: '',
      itemOneImage:
        'https://s1.thcdn.com/widgets/95-en/30/TO_Blog_2-050730.jpg?width=660&height=440',
      itemThreeTitle: 'Blemish',
      itemThreeUrl:
        'https://www.lookfantastic.com/brands/the-ordinary/educating-with-the-ordinary/blemish.list',
      itemThreeCTA: 'SHOP NOW',
      itemThreeImage:
        'https://s1.thcdn.com/widgets/95-en/52/original-0913-STDCRE-21708-LF-EJ-Deciem_Brand-Batching-Shot_03507_x_417-050152.jpg?width=660&height=440',
      itemThreeDescription:
        "Kick blemish or acne-prone skin to the kerb with the need-to-know products that'll keep pesky pimples at bay.",
      itemThreeSubtitle: '',
      altItemThree: '',
      itemFourDescription:
        'Skincare and lifestyle solutions to help reduce the effects of stress on skin, body and mind.',
      itemFourSubtitle: '',
      itemFourImage:
        'https://static.thcdn.com/images/small/webp/widgets/95-en/40/original-STRESS-CATEGORY-PRODUCT-BANNER-101340.jpg?width=660&height=440',
      itemFourTitle: 'STRESS',
      itemFourCTA: 'SHOP NOW',
      itemFourUrl: '',
      altItemFour: '',
      noWrapItems: '',
      styleModifier: '',
      widgetLink: '',
      textAlignment: '',
    },
    {
      widgetType: 'simpletextwidget',
      __typename: 'simpletextwidget',
      pagePath: '/landing',
      id: 'responsiveSlot13',
      textAlign: 'center',
      title: 'JO MALONE LONDON',
      simpletextwidgetText: {
        content: [
          {
            content:
              'The height of both home and personal fragrances, Jo Malone London offer only the most elegant and carefully crafted blends for a truly iconic sensorial experience. Masters of fragrance, their famous Pomegranate Noir Cologne captures a blend of uplifting Pomegranete mixed with sweet undertones of Casablanca Lily.',
            __typename: 'RichContentItem',
            type: RichContentType.Html,
          },
        ],
        __typename: 'RichContent',
      },
    },
    {
      __typename: 'simpleTextWidgetSet',
      widgetType: 'simpleTextWidgetSet',
      id: 'responsiveSlot14',
      banners: [
        {
          textAlign: 'left',
          title: 'What is Member Perks?',
          simpletextwidgetText: {
            content: [
              {
                content:
                  '<p>Members Perks is an exclusive area, reserved just for members. We’ve partnered with big brands to provide our loyal customers with new exclusive offers every three months from food and drink to travel and clothing.</p><p>Want access? Sign up to Myprotein!</p>',
                __typename: 'RichContentItem',
                type: RichContentType.Html,
              },
            ],
            __typename: 'RichContent',
          },
          __typename: 'simpletextwidget',
        },
        {
          textAlign: 'left',
          title: "How Do I Access Member's Perks?",
          simpletextwidgetText: {
            content: [
              {
                content: `<p>If you have a Myprotein account and you’re opted in to receive marketing emails, simply login below, and you'll be taken straight to the members perks area. </p><p>Alternatively, you can access the members perks page from your account area.</p><p>If you have a Myprotein account, but haven’t opted in to receive marketing emails, simply login to your Myprotein account and update your preferences by selecting ‘check my account status’ below and select 'yes' to access exclusive offers.</p>`,
                __typename: 'RichContentItem',
                type: RichContentType.Html,
              },
            ],
            __typename: 'RichContent',
          },
          __typename: 'simpletextwidget',
        },
      ],
    },
    {
      __typename: 'GlobalSimpleTextCTAWidget',
      widgetType: 'GlobalSimpleTextCTAWidget',
      id: 'responsiveSlot15',
      itemOneCTAText: 'SHOP NOW',
      textAlign: 'center',
      itemOneURL: '',
      globalSimpleTextCTAWidgetText:
        'We passionately believe that quality cosmeceutical skincare should be affordable for every face. Formulated by our expert team of cosmetic chemists, our skincare range is renowned for delivering transformative results. Inspired by innovation and technology, our products deliver visible change within the skin. We hero active ingredients, advanced delivery systems, and stable, skin-syncing formulations, and don’t use unnecessary filler ingredients or excessive packaging. We are proudly Australian owned and operated. Who We Are We are skinnovators; industry leaders inspired by the latest cosmetic technology, active ingredients, and professional skin treatments. And it’s our appetite for innovation that informs all our institut products. What We Do We create skincare products that create change. We use the very best quality cosmeceutical ingredients, advanced delivery systems, and clean, cruelty-free formulations that sync with the skin to deliver transformative results. Our Promise We make high-performance cosmeceutical skincare affordable for every face.',
      title: 'ABOUT US',
    },
    {
      __typename: 'AccordionWidgetContainer',
      id: 'responsiveSlot16',
      titlePosition: 'center',
      heading: 'h1',
      title: 'LOOKFANTASTIC ADVENT CALENDAR FAQs',
      banners: [
        {
          __typename: 'AccordionWidget',
          title: 'What Is The LOOKFANTASTIC Advent Calendar?',
          content: {
            __typename: 'RichContent',
            content: [
              {
                __typename: 'RichContentItem',
                type: RichContentType.Html,
                content:
                  'Each year, LOOKFANTASTIC launches its very own Advent Calendar. Last year, this bestselling advent sold out on Pre-Order alone and now it’s back for 2021 bigger and better than ever. Our LOOKFANTASTIC Advent Calendar is packed with amazing beauty buys from some of our customers favourite brands. Behind each door is a beauty gift set to surprise and delight. You don’t want to miss the best beauty Advent Calendar this year has to offer.',
              },
            ],
          },
        },
        {
          __typename: 'AccordionWidget',
          title: 'What’s Inside The LOOKFANTASTIC Advent Calendar?',
          content: {
            __typename: 'RichContent',
            content: [
              {
                __typename: 'RichContentItem',
                type: RichContentType.Html,
                content:
                  'Behind each of the 25 doors in the LOOKFANTASTIC Advent Calendar, you’ll find some incredible beauty products that our customers LOVE! From hair care to skincare, makeup to fragrance, counting down the days to December 25th couldn’t be more fantastic!',
              },
            ],
          },
        },
        {
          __typename: 'AccordionWidget',
          title: 'When Does The LOOKFANTASTIC Advent Calendar Go On Sale?',
          content: {
            __typename: 'RichContent',
            content: [
              {
                __typename: 'RichContentItem',
                type: RichContentType.Html,
                content: `<p><b>Who can enter and entry restrictions:</b></p>
                <ul>
                   <li>
                      <p>you must be a resident in the UK (excluding Northern Ireland);</p>
                   </li>
                   <li>
                      <p>you must be 18 years of age at the time ofentry;</p>
                   </li>
                   <li>
                      <p>you must have internet access and an open Instagram account (this means that it is not set to a 'private' account). </p>
                   </li>
                </ul>
                <p></p>
                <p><b>HowTo Enter:</b></p>
                <p>To be entered into this Promotion, you will need to:</p>
                <p></p>
                <ol>
                   <li>
                      <p>like this post on the ‘Lookfantastic’ Instagramaccount;</p>
                   </li>
                </ol>
                <ol>
                   <li>
                      <p>tag at least one friend in the comments’ section of this post below (“Comment”) (to multiple your chance of winning you can add as many Comments as you wish); and</p>
                   </li>
                </ol>
                <ol>
                   <li>
                      <p>follow @lfbeautybox, and @lookfantastic and @mankindcouk.</p>
                   </li>
                </ol>
                <p></p>
                <p></p>
                <p>For the avoidance of doubt, you must still be following the account with your Comment(s) still active and visible when the winner is being selected to be eligible to participate in the Promotion. Two winners will be selected at random out of all the entries on the social media page.</p>
                <p></p>
                <p>You are not permitted to enter the Promotion if you are an employee of Lookfantastic or any THG company, their direct family member or agent, or if you are otherwise professionally connected with the Promotion.</p>
                <p></p>
                <p>In entering the Promotion, you confirm that you are eligible to do so and eligible to claim any prize or reward you may win.</p>
                <p></p>
                <p>It is free toenter into this Promotion and no purchase required to enter.</p>`,
              },
            ],
          },
        },
      ],
    },
    {
      __typename: 'GlobalTwoBestSellers',
      id: 'responsiveSlot17',
      ProductTwoButtonText: 'SHOP NOW',
      ProductTwo: {
        sku: 10556399,
        images: [
          {
            thumbnail:
              'https://s1.thcdn.com/productimg/70/70/10556399-1214672439765286.jpg',
            largeProduct:
              'https://s1.thcdn.com/productimg/300/300/10556399-1214672439765286.jpg',
            zoom:
              'https://s1.thcdn.com/productimg/960/960/10556399-1214672439765286.jpg',
            __typename: 'ProductImage',
          },
          {
            thumbnail:
              'https://s1.thcdn.com/productimg/70/70/10556399-1224742939387397.jpg',
            largeProduct:
              'https://s1.thcdn.com/productimg/300/300/10556399-1224742939387397.jpg',
            zoom:
              'https://s1.thcdn.com/productimg/960/960/10556399-1224742939387397.jpg',
            __typename: 'ProductImage',
          },
          {
            thumbnail:
              'https://s1.thcdn.com/productimg/70/70/10556399-5144742939499045.jpg',
            largeProduct:
              'https://s1.thcdn.com/productimg/300/300/10556399-5144742939499045.jpg',
            zoom:
              'https://s1.thcdn.com/productimg/960/960/10556399-5144742939499045.jpg',
            __typename: 'ProductImage',
          },
        ],
        product: {
          reviews: {
            averageScore: 4.91,
            total: 23,
            __typename: 'ProductReviews',
          },
          url:
            '/ardell-duo-striplash-adhesive-glue-7g-white-clear/10556399.html',
          __typename: 'Product',
        },
        title: 'Duo Striplash Adhesive Glue 7g - White/Clear',
        __typename: 'ProductVariant',
      },
      ProductOneButtonText: 'SHOP NOW',
      ProductOne: {
        sku: 11471837,
        images: [
          {
            thumbnail:
              'https://s1.thcdn.com/productimg/70/70/11471837-3944808051239701.jpg',
            largeProduct:
              'https://s1.thcdn.com/productimg/300/300/11471837-3944808051239701.jpg',
            zoom:
              'https://s1.thcdn.com/productimg/960/960/11471837-3944808051239701.jpg',
            __typename: 'ProductImage',
          },
          {
            thumbnail:
              'https://s1.thcdn.com/productimg/70/70/11471837-1194808051253720.jpg',
            largeProduct:
              'https://s1.thcdn.com/productimg/300/300/11471837-1194808051253720.jpg',
            zoom:
              'https://s1.thcdn.com/productimg/960/960/11471837-1194808051253720.jpg',
            __typename: 'ProductImage',
          },
        ],
        product: {
          reviews: {
            averageScore: 5,
            total: 1,
            __typename: 'ProductReviews',
          },
          url: '/mac-lash-30/11471837.html',
          __typename: 'Product',
        },
        title: 'MAC Lash - 30',
        __typename: 'ProductVariant',
      },
    },
    {
      __typename: 'AccordionWidgetContainer',
      id: 'responsiveSlot18',
      titlePosition: 'alternate',
      heading: 'h1',
      title: 'LOOKFANTASTIC ADVENT CALENDAR FAQs (Alternate Layout)',
      banners: [
        {
          __typename: 'AccordionWidget',
          title: 'What Is The LOOKFANTASTIC Advent Calendar?',
          content: {
            __typename: 'RichContent',
            content: [
              {
                __typename: 'RichContentItem',
                type: RichContentType.Html,
                content:
                  'Each year, LOOKFANTASTIC launches its very own Advent Calendar. Last year, this bestselling advent sold out on Pre-Order alone and now it’s back for 2021 bigger and better than ever. Our LOOKFANTASTIC Advent Calendar is packed with amazing beauty buys from some of our customers favourite brands. Behind each door is a beauty gift set to surprise and delight. You don’t want to miss the best beauty Advent Calendar this year has to offer.',
              },
            ],
          },
        },
        {
          __typename: 'AccordionWidget',
          title: 'What’s Inside The LOOKFANTASTIC Advent Calendar?',
          content: {
            __typename: 'RichContent',
            content: [
              {
                __typename: 'RichContentItem',
                type: RichContentType.Html,
                content:
                  'Behind each of the 25 doors in the LOOKFANTASTIC Advent Calendar, you’ll find some incredible beauty products that our customers LOVE! From hair care to skincare, makeup to fragrance, counting down the days to December 25th couldn’t be more fantastic!',
              },
            ],
          },
        },
        {
          __typename: 'AccordionWidget',
          title: 'When Does The LOOKFANTASTIC Advent Calendar Go On Sale?',
          content: {
            __typename: 'RichContent',
            content: [
              {
                __typename: 'RichContentItem',
                type: RichContentType.Html,
                content: `<p><b>Who can enter and entry restrictions:</b></p>
                <ul>
                   <li>
                      <p>you must be a resident in the UK (excluding Northern Ireland);</p>
                   </li>
                   <li>
                      <p>you must be 18 years of age at the time ofentry;</p>
                   </li>
                   <li>
                      <p>you must have internet access and an open Instagram account (this means that it is not set to a 'private' account). </p>
                   </li>
                </ul>
                <p></p>
                <p><b>HowTo Enter:</b></p>
                <p>To be entered into this Promotion, you will need to:</p>
                <p></p>
                <ol>
                   <li>
                      <p>like this post on the ‘Lookfantastic’ Instagramaccount;</p>
                   </li>
                </ol>
                <ol>
                   <li>
                      <p>tag at least one friend in the comments’ section of this post below (“Comment”) (to multiple your chance of winning you can add as many Comments as you wish); and</p>
                   </li>
                </ol>
                <ol>
                   <li>
                      <p>follow @lfbeautybox, and @lookfantastic and @mankindcouk.</p>
                   </li>
                </ol>
                <p></p>
                <p></p>
                <p>For the avoidance of doubt, you must still be following the account with your Comment(s) still active and visible when the winner is being selected to be eligible to participate in the Promotion. Two winners will be selected at random out of all the entries on the social media page.</p>
                <p></p>
                <p>You are not permitted to enter the Promotion if you are an employee of Lookfantastic or any THG company, their direct family member or agent, or if you are otherwise professionally connected with the Promotion.</p>
                <p></p>
                <p>In entering the Promotion, you confirm that you are eligible to do so and eligible to claim any prize or reward you may win.</p>
                <p></p>
                <p>It is free toenter into this Promotion and no purchase required to enter.</p>`,
              },
            ],
          },
        },
      ],
    },
    {
      __typename: 'AccordionWidget',
      title: 'When Does The LOOKFANTASTIC Advent Calendar Go On Sale?',
      id: 'responsiveSlot19',
      content: {
        __typename: 'RichContent',
        content: [
          {
            __typename: RichContentType.Html,
            content: `The LOOKFANTASTIC Advent Calendar will go on sale in advance of the Christmas countdown, meaning you’ll get your calendar in plenty of time. No peeking until December 1st though!

              Our 2021 LOOKFANTASTIC Advent Calendar will be on sale to subscribers on Wednesday the 1st of September at 12pm. While non-subscribers will be able to buy theirs on general sale from Thursday the 2nd of September at 12pm.`,
          },
        ],
      },
    },
    {
      __typename: 'GlobalSixItemCategories',
      id: 'responsiveSlot20',
      itemTwoCTA: 'Use code: HOT',
      itemTitleAlign: 'center',
      itemTwoLink: '/brands/ultrasun/view-all.list',
      itemOneLink: '/brands/filorga/view-all.list',
      itemTwoImage:
        'https://static.thcdn.com/images/small/webp/widgets/95-en/36/Ultrasun_Aftersun-091536.jpg',
      altItemTwo: 'Ultrasun 33% off',
      altItemFive: 'Erno Laslzo 30% off',
      itemFiveImage:
        'https://static.thcdn.com/images/small/webp/widgets/95-en/10/original-ERNO_LASZLO_020720_ON_PINK_054-091710.jpg',
      itemThreeCTA: 'Use code: HOT',
      itemSixImage:
        'https://static.thcdn.com/images/small/webp/widgets/95-en/23/original-507x417_%284%29-091723.png',
      altItemFour: 'Farmacy 30% off',
      itemFourImage:
        'https://static.thcdn.com/images/small/webp/widgets/95-en/30/original-LookFantastic_DesktopBanner_507x417-091630.png',
      title: 'Shop by Brands',
      itemCTAAlign: 'center',
      itemThreeImage:
        'https://static.thcdn.com/images/small/webp/widgets/95-en/54/original-Banner_507x417-091554.jpg',
      itemFourCTA: 'Use code: HOT',
      itemFiveLink: '/brands/erno-laszlo/all-erno-laszlo.list',
      itemFourTitle: 'Farmacy 30% off',
      itemThreeLink: '/brands/aquis/view-all.list',
      itemOneImage:
        'https://static.thcdn.com/images/small/webp/widgets/95-en/22/original-Meso_Mask_507x417-091522.jpg',
      itemSixCTA: 'Use code: HOT',
      itemTwoTitle: 'Ultrasun 33% off',
      itemFourLink: '/brands/farmacy.list',
      altItemThree: 'Aquis 33% off',
      itemFiveCTA: 'Use code: HOT',
      itemSixTitle: 'Sarah Chapman 30% off',
      itemOneTitle: 'Filorga 33% off',
      itemFiveTitle: 'Erno Laslzo 30% off',
      itemSixLink: '/brands/sarah-chapman/all-sarah-chapman.list',
      altItemSix: 'Sarah Chapman 30% off',
      itemThreeTitle: 'Aquis 33% off',
      itemOneCTA: 'Use code: HOT',
      altItemOne: 'Filorga 33% off',
    },
    {
      __typename: 'multiCategoryCardSet',
      id: 'responsiveSlot21',
      widgetSubtitle: 'DISCOVER MORE SUSTAINABLE LABELS',
      columnsNumber: 4,
      banners: [
        {
          __typename: 'categoryItemCard',
          itemTitle: 'Faithfull The Brand',
          textAlignment: 'left',
          itemImagePath:
            'https://static.thcdn.com/images/small/webp/widgets/94-en/45/Agi_Faithfull_05e_copy_424x565-100845.jpg',
          itemDescription:
            'Supporting local Balinese artisans that create beautiful handmade pieces',
          altTextitem: 'Faithfull The Brand',
          itemUrl: '/woman/brand/faithfull-the-brand.list',
          itemCTA: 'Faithfull The Brand',
        },
        {
          __typename: 'categoryItemCard',
          itemTitle: 'Skall Studio',
          textAlignment: 'left',
          itemImagePath:
            'https://static.thcdn.com/images/small/webp/widgets/94-en/54/Skall_Studio_Garden-103454.jpg',
          itemDescription:
            'Skall Studio is the sustainable Danish label that creates timeless, elegant, feminine clothing with exceptional quality.',
          altTextitem: 'Skall Studio',
          itemUrl: '/brand/skall-studio.list',
          itemCTA: 'Skall Studio',
        },
        {
          __typename: 'categoryItemCard',
          itemTitle: 'Avant Skincare',
          textAlignment: 'left',
          itemImagePath:
            'https://static.thcdn.com/images/small/webp/widgets/94-en/51/social-AV030-AV070-web_%282%29_424x565-111451.jpg',
          itemDescription:
            'The forward thinking skincare label free from animal derivatives and animal testing',
          altTextitem: 'Avant Skincare',
          itemUrl: '/beauty/brand/avant-skincare.list',
          itemCTA: 'Avant Skincare',
        },
        {
          __typename: 'categoryItemCard',
          itemTitle: 'The Little Green Sheep',
          textAlignment: 'left',
          itemImagePath:
            'https://static.thcdn.com/images/small/webp/widgets/94-en/03/6._Dove_RoomSet_image_LR_424x565-111503.jpg',
          itemDescription:
            'Skall Studio is the sustainable Danish label that creates timeless, elegant, feminine clothing with exceptional quality.',
          altTextitem: 'The Little Green Sheep',
          itemUrl: '/homewares/brand/the-little-green-sheep.list',
          itemCTA: 'The Little Green Sheep',
        },
        {
          __typename: 'categoryItemCard',
          itemTitle: 'Bang & Olufsen',
          textAlignment: 'left',
          itemImagePath:
            'https://static.thcdn.com/images/small/webp/widgets/94-en/10/Beoplay_HX_0082_424x565-101110.jpg',
          itemDescription:
            'The forward thinking skincare label free from animal derivatives and animal testing',
          altTextitem: 'Bang & Olufsen',
          itemUrl: '/homewares/brand/bang-olufsen.list',
          itemCTA: 'Bang & Olufsen',
        },
      ],
      widgetTitle: 'Sustainable Brands',
    },
    {
      __typename: 'GlobalTwoItemImageTextCTA',
      id: 'responsiveSlot22',
      itemOneTitle: 'Item One Title',
      itemOneDescription:
        'This is the description for item one. Use two or three lines for optimum display on smaller devices.',
      itemOneImage:
        'https://blogscdn.thehut.net/app/uploads/sites/478/2020/09/Icecream1200x672-featute_1599119209-700x392.jpg',
      itemOneImageSmall:
        'https://static.thcdn.com/images/medium/webp/widgets/83-en/../showcase/images/twoItemImageTextCTA/twoItemImageTextCTA-652x391.png',
      itemOneImageAltText: '',
      itemOneCTAText: 'CTA Link 1',
      itemOneURL: '/',
      itemTwoTitle: 'test',
      itemTwoDescription:
        'This is the description for item one. Use two or three lines for optimum display on smaller devices.',
      itemTwoURL: '/',
      itemTwoImageSmall:
        'https://static.thcdn.com/images/medium/webp/widgets/83-en/../showcase/images/twoItemImageTextCTA/twoItemImageTextCTA-652x391.png',
      contentTheme: '',
      itemTwoImage:
        'https://blogscdn.thehut.net/app/uploads/sites/478/2020/09/Icecream1200x672-featute_1599119209-700x392.jpg',
      itemTwoCTAText: 'CTA Link 2',
      itemTwoImageAltText: '',
      itemOneContentAlign: '',
      itemTwoContentAlign: '',
    },
    {
      id: '2672648',
      __typename: 'GlobalSectionPeek',
      productCount: 4,
      title: 'Best Sellers',
      url: '/nutrition/bestsellers-en-gb.list',
      titleAlign: 'center',
    },
    {
      __typename: 'GlobalFourBestSellers',
      id: 'responsiveSlot23',
      ProductTwoButtonText: 'SHOP NOW',
      ProductTwo: {
        sku: 12635437,
        __typename: 'ProductVariant',
        images: [
          {
            thumbnail:
              'https://s1.thcdn.com/productimg/70/70/12635437-1314911951568611.jpg',
            largeProduct:
              'https://s1.thcdn.com/productimg/300/300/12635437-1314911951568611.jpg',
            zoom:
              'https://s1.thcdn.com/productimg/960/960/12635437-1314911951568611.jpg',
            __typename: 'ProductImage',
          },
        ],
        product: {
          reviews: {
            averageScore: 4.62,
            total: 104,
            __typename: 'ProductReviews',
          },
          url:
            '/christophe-robin-cleansing-purifying-scrub-with-sea-salt-250ml/12635437.html',
          __typename: 'Product',
        },
        title: 'Christophe Robin Cleansing Purifying Scrub with Sea Salt 250ml',
      },
      ProductThreeButtonText: 'SHOP NOW',
      ProductFourButtonText: 'SHOP NOW',
      ProductOneButtonText: 'SHOP NOW',
      ProductOne: {
        sku: 12635435,
        __typename: 'ProductVariant',
        images: [
          {
            thumbnail:
              'https://s1.thcdn.com/productimg/70/70/12635435-1334911951506958.jpg',
            largeProduct:
              'https://s1.thcdn.com/productimg/300/300/12635435-1334911951506958.jpg',
            zoom:
              'https://s1.thcdn.com/productimg/960/960/12635435-1334911951506958.jpg',
            __typename: 'ProductImage',
          },
        ],
        product: {
          reviews: {
            averageScore: 4.69,
            total: 78,
            __typename: 'ProductReviews',
          },
          url:
            '/christophe-robin-regenerating-mask-with-prickly-pear-oil-250ml/12635435.html',
          __typename: 'Product',
        },
        title: 'Christophe Robin Regenerating Mask with Prickly Pear Oil 250ml',
      },
      Title: '<br>BESTSELLERS',
      ProductThree: {
        sku: 12696147,
        __typename: 'ProductVariant',
        images: [
          {
            thumbnail:
              'https://s1.thcdn.com/productimg/70/70/12696147-2194911951443475.jpg',
            largeProduct:
              'https://s1.thcdn.com/productimg/300/300/12696147-2194911951443475.jpg',
            zoom:
              'https://s1.thcdn.com/productimg/960/960/12696147-2194911951443475.jpg',
            __typename: 'ProductImage',
          },
        ],
        product: {
          reviews: {
            averageScore: 4.16,
            total: 49,
            __typename: 'ProductReviews',
          },
          url:
            '/christophe-robin-cleansing-volumising-paste-with-pure-rassoul-clay-and-rose-250ml/12696147.html',
          __typename: 'Product',
        },
        title:
          'Christophe Robin Cleansing Volumising Paste with Pure Rassoul Clay and Rose 250ml',
      },
      disableTitle: '',
      ProductFour: {
        sku: 12635446,
        __typename: 'ProductVariant',
        images: [
          {
            thumbnail:
              'https://s1.thcdn.com/productimg/70/70/12635446-5394893266087187.jpg',
            largeProduct:
              'https://s1.thcdn.com/productimg/300/300/12635446-5394893266087187.jpg',
            zoom:
              'https://s1.thcdn.com/productimg/960/960/12635446-5394893266087187.jpg',
            __typename: 'ProductImage',
          },
        ],
        product: {
          reviews: {
            averageScore: 4.43,
            total: 7,
            __typename: 'ProductReviews',
          },
          url:
            '/christophe-robin-regenerating-shampoo-with-prickly-pear-oil-250ml/12635446.html',
          __typename: 'Product',
        },
        title:
          'Christophe Robin Regenerating Shampoo with Prickly Pear Oil 250ml',
      },
    },
    {
      __typename: 'ResponsiveProductBlockCarousel',
      id: 'responsiveSlot24',
      enableAsiaStyles: '',
      title: 'OUR BEAUTY TEAM ARE LOVING',
      skuList: [
        {
          sku: 13494908,
          title:
            'La Roche-Posay Anthelios UVMune 400 Invisible Fluid Tinted SPF50+ 50ml',
          __typename: 'ProductVariant',
          images: [
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13494908-8634932952103553.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13494908-8634932952103553.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13494908-8634932952103553.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13494908-1714932952149699.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13494908-1714932952149699.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13494908-1714932952149699.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13494908-1284932952387119.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13494908-1284932952387119.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13494908-1284932952387119.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13494908-7374932952211826.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13494908-7374932952211826.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13494908-7374932952211826.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13494908-1474932952259580.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13494908-1474932952259580.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13494908-1474932952259580.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13494908-6784932951394350.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13494908-6784932951394350.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13494908-6784932951394350.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13494908-1204932951446766.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13494908-1204932951446766.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13494908-1204932951446766.jpg',
              __typename: 'ProductImage',
            },
          ],
          product: {
            reviews: {
              averageScore: 3.5,
              total: 4,
              __typename: 'ProductReviews',
            },
            url:
              '/la-roche-posay-anthelios-uvmune-400-invisible-fluid-tinted-spf50-50ml/13494908.html',
            __typename: 'Product',
          },
          clickAndCollectStores: [],
          eligibleForFulfilmentMethods: [],
          isAutoRenewSubscription: false,
          isSubscription: false,
          subscriptionContracts: [],
        },
        {
          sku: 13313010,
          title: 'Sun Bum Original SPF 50 Sunscreen Lotion',
          __typename: 'ProductVariant',
          images: [
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13313010-1514964039988333.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13313010-1514964039988333.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13313010-1514964039988333.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13313010-5954964040029949.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13313010-5954964040029949.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13313010-5954964040029949.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13313010-3944898215172370.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13313010-3944898215172370.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13313010-3944898215172370.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13313010-2934899088486251.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13313010-2934899088486251.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13313010-2934899088486251.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13313010-1984900870353960.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13313010-1984900870353960.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13313010-1984900870353960.jpg',
              __typename: 'ProductImage',
            },
          ],
          product: {
            reviews: {
              averageScore: 0,
              total: 0,
              __typename: 'ProductReviews',
            },
            url: '/sun-bum-original-spf-50-sunscreen-lotion/13313010.html',
            __typename: 'Product',
          },
          clickAndCollectStores: [],
          eligibleForFulfilmentMethods: [],
          isAutoRenewSubscription: false,
          isSubscription: false,
          subscriptionContracts: [],
        },
        {
          sku: 13652186,
          title:
            'Diego Dalla Palma Tan Tan Gradual Self-Tanning Body Serum 60ml',
          __typename: 'ProductVariant',
          images: [
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/13652186-2114955272834407.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/13652186-2114955272834407.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/13652186-2114955272834407.jpg',
              __typename: 'ProductImage',
            },
          ],
          product: {
            reviews: {
              averageScore: 0,
              total: 0,
              __typename: 'ProductReviews',
            },
            url:
              '/diego-dalla-palma-tan-tan-gradual-self-tanning-body-serum-60ml/13652186.html',
            __typename: 'Product',
          },
          clickAndCollectStores: [],
          eligibleForFulfilmentMethods: [],
          isAutoRenewSubscription: false,
          isSubscription: false,
          subscriptionContracts: [],
        },
        {
          sku: 12274850,
          title: 'Illamasqua Beyond Liquid Highlighter - OMG',
          __typename: 'ProductVariant',
          images: [
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/12274850-4624874597346384.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/12274850-4624874597346384.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/12274850-4624874597346384.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/12274850-4264869422556633.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/12274850-4264869422556633.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/12274850-4264869422556633.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/12274850-4244869422615661.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/12274850-4244869422615661.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/12274850-4244869422615661.jpg',
              __typename: 'ProductImage',
            },
            {
              thumbnail:
                'https://s1.thcdn.com/productimg/70/70/12274850-2134869422654976.jpg',
              largeProduct:
                'https://s1.thcdn.com/productimg/300/300/12274850-2134869422654976.jpg',
              zoom:
                'https://s1.thcdn.com/productimg/960/960/12274850-2134869422654976.jpg',
              __typename: 'ProductImage',
            },
          ],
          product: {
            reviews: {
              averageScore: 4.5,
              total: 10,
              __typename: 'ProductReviews',
            },
            url: '/illamasqua-beyond-liquid-highlighter-omg/12274850.html',
            __typename: 'Product',
          },
          clickAndCollectStores: [],
          eligibleForFulfilmentMethods: [],
          isAutoRenewSubscription: false,
          isSubscription: false,
          subscriptionContracts: [],
        },
      ],
    },
    {
      __typename: 'GlobalTwoItemImageTextBlock',
      id: 'responsiveSlot25',
      button2Url:
        'https://s1.thcdn.com/design-assets/documents/speedo/Speedo%20Sustainability%20Report%20100%25.pdf" target=_"blank',
      itemButton: '',
      itemAlign: 'left',
      itemTitle: 'Our Commitment to Sustainability',
      textAlign: 'default',
      itemImageSmall:
        'https://s1.thcdn.com/widgets/241-en/44/original-04-021244.png',
      videoTitle: '',
      itemText: {
        content: [
          {
            content:
              "We know there's more we need to do to make positive changes to help the planet, which is why it's a key focus in every area of the business.",
            __typename: 'RichContentItem',
            type: RichContentType.Html,
          },
        ],
        __typename: 'RichContent',
      },
      itemImage:
        'https://s1.thcdn.com/widgets/241-en/41/original-04-021241.png',
      transcript: {
        content: [
          {
            content: '',
            __typename: 'RichContentItem',
            type: RichContentType.Html,
          },
        ],
        __typename: 'RichContent',
      },
      itemAlt: 'Our commitment to sustainability',
      videoUrl: '',
      button2Text: 'Download Our Full PDF Report',
      itemURL: '',
    },
    {
      id: '3353545',
      __typename: 'TopProductCategorySet',
      showDiscoverTag: '',
      showMore: '',
      DiscoverTitle: '',
      banners: [
        {
          id: '3353545-banners-0',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Complexion',
          topProductCategoryUrl: '/health-beauty/make-up/complexion.list',
        },
        {
          id: '3353545-banners-1',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Eyes and Brows',
          topProductCategoryUrl: '/health-beauty/make-up/eyes.list',
        },
        {
          id: '3353545-banners-2',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Lips',
          topProductCategoryUrl: '/health-beauty/make-up/lips.list',
        },
        {
          id: '3353545-banners-3',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Make up Brushes & Accessories',
          topProductCategoryUrl:
            '/health-beauty/make-up/makeup-accessories.list',
        },
        {
          id: '3353545-banners-4',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Complexion',
          topProductCategoryUrl: '/health-beauty/make-up/complexion.list',
        },
        {
          id: '3353545-banners-5',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Eyes and Brows',
          topProductCategoryUrl: '/health-beauty/make-up/eyes.list',
        },
        {
          id: '3353545-banners-6',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Lips',
          topProductCategoryUrl: '/health-beauty/make-up/lips.list',
        },
        {
          id: '3353545-banners-7',
          __typename: 'TopProductCategory',
          buttonStyle: '',
          topProductCategoryName: 'Make up Brushes & Accessories',
          topProductCategoryUrl:
            '/health-beauty/make-up/makeup-accessories.list',
        },
      ],
    },
  ],
  __typename: 'Page',
}

export const MOCK_CONCESSION_DATA = {
  concession: {
    concessionCode: 'DuluxHeritage',
    footer: {
      navigation: {
        topLevel: [
          {
            type: 'TEXT',
            image: null,
            link: {
              url: '/customer-services.list',
              text: 'Customer Services',
              __typename: 'Hyperlink',
            },
            displayName: 'Customer Services',
            iconName: null,
            __typename: 'NavigationItem',
          },
          {
            type: 'TEXT',
            image: null,
            link: {
              url: '/customer-services/resources.list',
              text: 'Resources',
              __typename: 'Hyperlink',
            },
            displayName: 'Resources',
            iconName: null,
            __typename: 'NavigationItem',
          },
          {
            type: 'TEXT',
            image: null,
            link: null,
            displayName: 'Top Categories',
            iconName: null,
            __typename: 'NavigationItem',
          },
          {
            type: 'TEXT',
            image: null,
            link: null,
            displayName: 'About Us',
            iconName: null,
            __typename: 'NavigationItem',
          },
        ],
        __typename: 'Navigation',
      },
      __typename: 'Footer',
    },
    header: {
      navigation: {
        topLevel: [
          {
            image: null,
            link: {
              url: 'https://www.homebase.co.uk/',
              text: 'Go To Homebase',
              __typename: 'Hyperlink',
            },
            iconName: null,
            displayName: 'Go To Homebase',
          },
          {
            image: null,
            link: {
              url: '/paint-decorating/paint/dulux-heritage.list',
              text: 'Dulux Heritage',
              __typename: 'Hyperlink',
            },
            iconName: null,
            displayName: 'Dulux Heritage',
          },
          {
            image: null,
            link: {
              url: '/paint-decorating/paint/dulux-heritage/shop-by-colour.list',
              text: 'Shop by Colour',
              __typename: 'Hyperlink',
            },
            iconName: null,
            displayName: 'Shop by Colour',
          },
          {
            image: null,
            link: {
              url:
                '/paint-decorating/paint/dulux-heritage/dulux-heritage-paint-calculator.list',
              text: 'Paint Calculator ',
              __typename: 'Hyperlink',
            },
            iconName: null,
            displayName: 'Paint Calculator ',
          },
        ],
        __typename: 'Navigation',
      },
      __typename: 'Header',
    },
    __typename: 'Concession',
  },
}
